/**
 * Environment-safe Logger — unterdrückt Logs in Production.
 * DSGVO-konform: Keine PHI, keine User-IDs in Prod-Logs.
 */
const isDev = import.meta.env.DEV;

export const logger = {
  debug: (...args: unknown[]) => {
    if (isDev) console.debug('[MediFlow Pflege]', ...args);
  },
  info: (...args: unknown[]) => {
    if (isDev) console.log('[MediFlow Pflege]', ...args);
  },
  warn: (...args: unknown[]) => {
    console.warn('[MediFlow Pflege]', ...args);
  },
  error: (...args: unknown[]) => {
    console.error('[MediFlow Pflege]', ...args);
  },
} as const;
